import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorks } from './components/HowItWorks';
import { CoreBenefit } from './components/CoreBenefit';
import { Features } from './components/Features';
import { SocialProof } from './components/SocialProof';
import { PerfectFor } from './components/PerfectFor';
import { ProductVisual } from './components/ProductVisual';
import { UrgencyCTA } from './components/UrgencyCTA';
import { FAQ } from './components/FAQ';
import { StickyBuyButton } from './components/StickyBuyButton';
export function App() {
  return <div className="min-h-screen bg-dark font-sans text-cream selection:bg-gold/30 selection:text-cream pb-24 md:pb-0" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <CoreBenefit data-id="element-6" />
        <Features data-id="element-7" />
        <SocialProof data-id="element-8" />
        <PerfectFor data-id="element-9" />
        <ProductVisual data-id="element-10" />
        <UrgencyCTA data-id="element-11" />
        <FAQ data-id="element-12" />
      </main>

      <footer className="bg-dark border-t border-gold/10 py-8 text-center text-cream-dark/50 text-sm" data-id="element-13">
        <p data-id="element-14">
          © {new Date().getFullYear()} TapShare Events. All rights reserved.
        </p>
      </footer>

      <StickyBuyButton data-id="element-15" />
    </div>;
}